import adobeAnalytics from './Analytics';

export default adobeAnalytics;
